/**
 * Zelf Zorgen Samen Doen
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';

/**
 * Controller for scroll anchors or buttons.
 */
export default class extends Controller {
  static targets = ['scroll'];

  /**
   * Scroll target element.
   *
   * @param {Event} e
   */
  onScroll(e) {
    e.preventDefault();

    if (this.hasScrollTarget) {
      this.scrollTarget.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
